export { GlobalContextProvider, useGlobalContext } from './globalContext';
